import(/* webpackMode: "eager" */ "/usr/src/app/apps/crm-app/src/app/global-error.tsx");
